import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function CloudPlatformEngineerRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month Cloud/Platform Engineer Career Roadmap`}
      subtitle="Cloud Infrastructure Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-cloud-platform-engineer-roadmap.pdf"
      roleKey={roleKey || "cloudplatformengineer"}
    />
  );
}

